import { OgpApiService } from './ogp-api-service';
import { CertificateDataOGP } from './accreditations-service.types';

type BackendEmployeeCertificateItem = {
  accreditationId: string;
  certificateId: string;
  certificateName: string;
  startDate: string | null;
  expirationDate: string | null;
  type: string;
  state: string;
  isTrusted: boolean;
};

type BackendGetEmployeeCertificatesResponse = {
  items: BackendEmployeeCertificateItem[];
  totalRows: number;
  nextPage?: number;
  previousPage?: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

class AccreditationsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public async getAccreditations(flexWorkerId: string) {
    const response = await this.ogpApiService.get<CertificateDataOGP[]>({
      path: `accreditations/${flexWorkerId}`,
    });
    return response;
  }

  public async getEmployeeCertificates(
    flexWorkerId: string,
    pageParam: number,
    pageSizeParam: number
  ): Promise<BackendGetEmployeeCertificatesResponse> {
    const response = await this.ogpApiService.get<BackendGetEmployeeCertificatesResponse>({
      path: `workforce/${flexWorkerId}/certificates`,
      params: {
        pageParam,
        pageSizeParam,
      },
    });
    return response;
  }

  public async trustAccreditation(flexWorkerId: string, accreditationId: string): Promise<void> {
    await this.ogpApiService.create({
      path: `workforce/${flexWorkerId}/certificates/${accreditationId}/trust`,
    });
  }

  public async untrustAccreditation(flexWorkerId: string, accreditationId: string): Promise<void> {
    await this.ogpApiService.delete({
      path: `workforce/${flexWorkerId}/certificates/${accreditationId}/trust`,
    });
  }
}

export { AccreditationsService };
